// extracted by mini-css-extract-plugin
export default {"breakpoint_tablet_max_width_1199":"1199px","sort_list":"fas_sort_list","list_item":"fas_list_item","selected_value":"fas_selected_value"};